import { render, staticRenderFns } from "./Saques.vue?vue&type=template&id=0de613e1&"
import script from "./Saques.vue?vue&type=script&lang=js&"
export * from "./Saques.vue?vue&type=script&lang=js&"
import style0 from "./Saques.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports